import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { fetchReportInfo, sendReportNow } from "@/lib/api";

const fmt = (iso) =>
  iso ? new Date(iso).toLocaleString("ro-RO", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Bucharest" }) : "—";

export default function ReportPanel() {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    fetchReportInfo().then(setInfo).catch(() => {});
  }, []);

  const send = async () => {
    setBusy(true);
    try {
      const r = await sendReportNow();
      if (r.queued) toast.success("Raportul se trimite · ajunge pe email în câteva secunde");
      else toast.info("Raportul a fost trimis acum câteva minute · încearcă din nou peste 2 minute");
    } catch {
      toast.error("Nu am putut trimite raportul");
    }
    setBusy(false);
  };

  return (
    <section className="invite-box" data-testid="report-panel">
      <h3>Raport săptămânal</h3>
      <p className="st-hint">
        În fiecare luni la 08:00 primești pe <b data-testid="report-email">{info?.to || "…"}</b> clienții aduși prin linkul fiecărui agent, topul agenților activi și lista celor inactivi din ultimele 7 zile.
        Următorul raport: <b data-testid="report-next-run">{fmt(info?.next_run)}</b>.
      </p>
      <div>
        <button type="button" className="st-btn st-btn--ghost" onClick={send} disabled={busy} data-testid="report-send-now-btn">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Mail size={16} />} Trimite raportul acum
        </button>
      </div>
    </section>
  );
}
